export const SPINNER_TEXT = {
  /** 보조기기에 읽히는 기본 문구 */
  label: '불러오는 중',
} as const;
